export interface Attribute {
    category: string
    name: string
    value: number
}

export interface AvailablePrinter {
    name: string
    code: string
    attributes?: Attribute[]
}

///

export enum AnapathPrinterPrintMode {
    PRINT = 'print',
    PRINT_LABELS = 'printLabels'
}

export interface AnapathPrinterPrintParams {
    trayName?: string
}

export interface AnapathPrinterPrintConfiguration {
    printMode: AnapathPrinterPrintMode
    timeout?: number
    params?: AnapathPrinterPrintParams
}
